const kirkpatrickLevels = [
  { level: 1, title: 'Реакция', question: 'Понравилось ли обучение?', desc: 'Базовый уровень. Анкеты обратной связи, оценка удовлетворённости участников. Важно, но недостаточно — положительные отзывы не гарантируют результат.', metrics: 'Net Promoter Score тренинга, средняя оценка удовлетворённости' },
  { level: 2, title: 'Знания', question: 'Что усвоили сотрудники?', desc: 'Тестирование до и после обучения. Насколько вырос уровень знаний по теме. Измеряет, что сотрудники запомнили и поняли.', metrics: 'Результаты тестов, % правильных ответов, прирост баллов' },
  { level: 3, title: 'Поведение', question: 'Что изменилось в работе?', desc: 'Самый важный и самый сложный для измерения уровень. Применяют ли сотрудники новые навыки в реальной работе через 1-3 месяца после обучения.', metrics: 'Оценка руководителем, наблюдение, % использования новых инструментов' },
  { level: 4, title: 'Результаты', question: 'Как изменился бизнес?', desc: 'Влияние обучения на бизнес-показатели: выручка, конверсия, средний чек, текучесть, NPS, количество ошибок.', metrics: 'Рост продаж %, рост NPS, снижение текучести %, ROI обучения' },
];

const kpiMetrics = [
  { name: 'Конверсия продаж', before: '12%', after: '18%', change: '+50%' },
  { name: 'Средний чек', before: '250 BYN', after: '340 BYN', change: '+36%' },
  { name: 'Длина сделки', before: '14 дней', after: '9 дней', change: '-36%' },
  { name: 'Повторные продажи', before: '22%', after: '35%', change: '+59%' },
  { name: 'Удержание клиентов (NPS)', before: '34', after: '52', change: '+53%' },
  { name: 'Текучесть персонала', before: '28%', after: '15%', change: '-46%' },
  { name: 'Скорость адаптации новичков', before: '3 мес', after: '1.5 мес', change: '-50%' },
  { name: 'Количество ошибок', before: '45/мес', after: '18/мес', change: '-60%' },
];

export default function HowToMeasure() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как измерить эффективность обучения персонала
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Оценка эффективности — это не анкета «Понравился ли вам тренинг?». Это система измеримых показателей на четырёх уровнях. Разбираем модель Киркпатрика, KPI и ROI обучения.
        </p>

        {/* Kirkpatrick Model */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10">Модель Киркпатрика: 4 уровня оценки</h3>
          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {kirkpatrickLevels.map((l) => (
              <div key={l.level} className="bg-gray-50 rounded-2xl p-6 border border-gray-100">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">{l.level}</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">Уровень {l.level}: {l.title}</h4>
                    <p className="text-sm text-teal-600">{l.question}</p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">{l.desc}</p>
                <div className="bg-white rounded-lg p-3 border border-gray-100">
                  <span className="text-xs font-semibold text-gray-500">Метрики: </span>
                  <span className="text-xs text-gray-700">{l.metrics}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ROI */}
        <div className="mb-16 max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">ROI корпоративного обучения</h3>
          <div className="bg-teal-50 rounded-2xl p-8 border border-teal-100">
            <div className="text-center mb-6">
              <div className="text-4xl font-extrabold text-teal-700 mb-2">ROI = (Прибыль &minus; Затраты) / Затраты &times; 100%</div>
              <p className="text-gray-600 text-sm">Простая формула, которая переводит обучение из «расходов» в «инвестиции»</p>
            </div>
            <div className="grid md:grid-cols-3 gap-4 text-center">
              <div className="bg-white rounded-xl p-4">
                <div className="text-sm text-gray-500 mb-1">Затраты на обучение</div>
                <div className="text-xl font-bold text-gray-900">15 000 BYN</div>
              </div>
              <div className="bg-white rounded-xl p-4">
                <div className="text-sm text-gray-500 mb-1">Рост прибыли за год</div>
                <div className="text-xl font-bold text-teal-600">78 000 BYN</div>
              </div>
              <div className="bg-white rounded-xl p-4">
                <div className="text-sm text-gray-500 mb-1">ROI обучения</div>
                <div className="text-xl font-bold text-teal-600">420%</div>
              </div>
            </div>
            <p className="text-sm text-gray-600 text-center mt-4">Реальный пример: компания из 80 сотрудников, программа обучения отдела продаж — рост конверсии с 12% до 18% за 6 месяцев</p>
          </div>
        </div>

        {/* KPI Table */}
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">KPI, которые показывают эффективность обучения</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="text-left py-3 px-4 font-semibold text-gray-900 rounded-l-xl">Показатель</th>
                  <th className="text-center py-3 px-4 text-red-600 font-semibold">До обучения</th>
                  <th className="text-center py-3 px-4 text-teal-600 font-semibold">После обучения</th>
                  <th className="text-center py-3 px-4 font-semibold text-gray-900 rounded-r-xl">Изменение</th>
                </tr>
              </thead>
              <tbody>
                {kpiMetrics.map((m, i) => (
                  <tr key={i} className="border-b border-gray-100">
                    <td className="py-3 px-4 font-medium text-gray-900">{m.name}</td>
                    <td className="py-3 px-4 text-center text-red-600">{m.before}</td>
                    <td className="py-3 px-4 text-center text-teal-600">{m.after}</td>
                    <td className="py-3 px-4 text-center font-bold text-teal-600">{m.change}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}